import {
	ChangeDetectionStrategy,
	Component, Inject
} from '@angular/core';
import { ROUTE_NAMES, RouterService } from '@go-modules/services/router/router.service';
import {
	SelectedService,
	selectedServiceToken
} from 'go-modules/services/selected/selected.service';
import { BreadCrumbStateService } from '@go-modules/services/breadcrumb-state/breadcrumb-state.service';
import { SeatOveragePolicies } from '@go-modules/enums/salesforce-license';

@Component({
	selector: 'licensing-breadcrumbs',
	templateUrl: './licensing-breadcrumbs.component.html',
	styleUrls: ['./licensing-breadcrumbs.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})

export class LicensingBreadcrumbsComponent {
	public readonly SeatOveragePolicies = SeatOveragePolicies;
	public States = ROUTE_NAMES;

	constructor (
		private routerService: RouterService,
		@Inject(selectedServiceToken) public selectedService: SelectedService,
		public breadcrumbStateService: BreadCrumbStateService
	) {}

	public goToLicenseManagement () {
		this.routerService.navigateTo(ROUTE_NAMES.LICENSE_MANAGEMENT);
	}
}
